var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#ECEDF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64896 14.2734L6.41797 17.9934L10.234 16.7934L7.64896 14.2734Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5177 7.56714L8.51172 13.4219L11.123 15.9674L17.129 10.1127L14.5177 7.56714Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5375 7.86L16.8141 6.18C16.5679 5.94 16.1986 5.94 15.9524 6.18L15.3984 6.72L17.9835 9.24L18.5375 8.7C18.7837 8.46 18.7837 8.1 18.5375 7.86Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.73208231f57730157a7a6eec951c3125.svg";
export { ForwardRef as ReactComponent };